import { useEffect, useState } from "react";

/* Horizontal scroller helpers: edge state only. Vertical wheel always scrolls the page; rows scroll via arrows, drag or trackpad horizontal swipe. */
export function useHScroll(ref, deps = []) {
  const [edge, setEdge] = useState({ left: false, right: false, pct: 0, overflow: false });
  useEffect(() => {
    const el = ref.current; if (!el) return;
    const measure = () => { const max = el.scrollWidth - el.clientWidth; setEdge({ left: el.scrollLeft > 4, right: el.scrollLeft < max - 4, pct: max > 0 ? Math.min(1, Math.max(0, el.scrollLeft / max)) : 1, overflow: max > 4 }); };
    measure();
    const ro = new ResizeObserver(measure); ro.observe(el);
    el.addEventListener("scroll", measure, { passive: true }); window.addEventListener("resize", measure);
    return () => { ro.disconnect(); el.removeEventListener("scroll", measure); window.removeEventListener("resize", measure); };
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps
  return edge;
}

// Touch / no-hover devices without "reduce motion": cards may auto-rotate while in view.
export function useTouchAutoplay() {
  const [on, setOn] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia("(hover: none)"), rm = window.matchMedia("(prefers-reduced-motion: reduce)");
    const upd = () => setOn(mq.matches && !rm.matches);
    upd(); mq.addEventListener?.("change", upd); rm.addEventListener?.("change", upd);
    return () => { mq.removeEventListener?.("change", upd); rm.removeEventListener?.("change", upd); };
  }, []);
  return on;
}

export function useFastConnection() {
  const [fast, setFast] = useState(true);
  useEffect(() => {
    const c = navigator.connection;
    const reduced = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    const slow = !!c && (c.saveData || ["slow-2g", "2g", "3g"].includes(c.effectiveType) || (c.downlink && c.downlink < 1.5));
    setFast(!slow && !reduced);
  }, []);
  return fast;
}

let _logoOverrides;
export function useLogoOverrides() {
  const [m, setM] = useState({});
  useEffect(() => { _logoOverrides ||= fetch(`${process.env.REACT_APP_BACKEND_URL}/api/orgs/logos`).then((r) => r.json()).then((d) => d.items || {}).catch(() => ({})); _logoOverrides.then(setM); }, []);
  return m;
}
